import axios from 'axios';
import {
  APP_SETTING_LOAD_APP_SETTING_PAGES_BEGIN,
  APP_SETTING_LOAD_APP_SETTING_PAGES_SUCCESS,
  APP_SETTING_LOAD_APP_SETTING_PAGES_FAILURE,
  APP_SETTING_LOAD_APP_SETTING_PAGES_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadAppSettingPages(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_APP_SETTING_PAGES_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${projectId}/project`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_APP_SETTING_PAGES_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_APP_SETTING_PAGES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadAppSettingPagesError() {
  return {
    type: APP_SETTING_LOAD_APP_SETTING_PAGES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_APP_SETTING_PAGES_BEGIN:
      return {
        ...state,
        loadAppSettingPagesPending: true,
        loadAppSettingPagesError: null,
      };

    case APP_SETTING_LOAD_APP_SETTING_PAGES_SUCCESS:
      return {
        ...state,
        loadAppSettingPagesPending: false,
        loadAppSettingPagesError: null,
        pages: action.data,
      };

    case APP_SETTING_LOAD_APP_SETTING_PAGES_FAILURE:
      return {
        ...state,
        loadAppSettingPagesPending: false,
        loadAppSettingPagesError: action.data.error,
      };

    case APP_SETTING_LOAD_APP_SETTING_PAGES_DISMISS_ERROR:
      return {
        ...state,
        loadAppSettingPagesError: null,
      };

    default:
      return state;
  }
}
